import type { ReactNode } from 'react';
import { Button, Card, Flex } from 'antd';

interface FilterPanelProps {
  children: ReactNode;
  /** When provided, shows a "clear filters" button. */
  onReset?: () => void;
  title?: ReactNode;
}

/** Container for list filters (date/operator/team/unit/risk/status). Lays controls out in a wrapping row. */
export default function FilterPanel({ children, onReset, title = 'فیلترها' }: FilterPanelProps) {
  return (
    <Card
      size="small"
      title={title}
      style={{ marginBottom: 16 }}
      extra={onReset ? <Button size="small" onClick={onReset}>پاک‌سازی</Button> : undefined}
    >
      <Flex wrap gap="middle" align="flex-end">
        {children}
      </Flex>
    </Card>
  );
}
